import { render, staticRenderFns } from "./standaloneRefunds.vue?vue&type=template&id=81f6433c&scoped=true"
import script from "./standaloneRefunds.vue?vue&type=script&lang=js"
export * from "./standaloneRefunds.vue?vue&type=script&lang=js"
import style0 from "./standaloneRefunds.vue?vue&type=style&index=0&id=81f6433c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f6433c",
  null
  
)

export default component.exports